import { z } from 'zod';
import { OptionalStringArray } from 'libs/end-to-end/src/generic';
import { createCustomVizRequestSchema } from 'libs/end-to-end/src/custom-viz/createCustomVizRequestSchema';
import { PayCorrectionAdjustedEmployeeSalaries } from 'libs/end-to-end/src/pay-correction/types/PayCorrectionAdjustedEmployeeSalaries';

export const PayCorrectionInputs = z.object({
  dropdowns: z.object({
    department: z.array(z.string()),
    location: z.array(z.string()),
    job_level: OptionalStringArray,
  }),
  extras: z.object({
    adjusted_salaries: PayCorrectionAdjustedEmployeeSalaries,
    dimension: z.string(),
    metric: z.string(),
  }),
});

export const PayCorrectionRequest = createCustomVizRequestSchema(
  'payCorrection',
  PayCorrectionInputs,
);

export type PayCorrectionRequest = z.infer<typeof PayCorrectionRequest>;
